import { render, staticRenderFns } from "./VxCheckbox.vue?vue&type=template&id=2163248b&scoped=true"
import script from "./VxCheckbox.vue?vue&type=script&lang=js"
export * from "./VxCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2163248b",
  null
  
)

export default component.exports